import React, {Component} from 'react';
import {Grid, Header} from "semantic-ui-react";
import ChangeUserEmail from "../auth/change_email";
import ChangePassword from "../auth/change_password";

class UserAccountSettings extends Component {

    render(){
        return(
            <div className="additional-pad">
                <Header size="large" content="Settings" textAlign="center"/>
                <Grid textAlign='center' style={{height: '100%'}} verticalAlign='middle'>
                    <Grid.Column width={8}>
                        <ChangeUserEmail/>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <ChangePassword/>
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

export default UserAccountSettings;


// WEBPACK FOOTER //
// ./src/views/user/user_account_settings.js